export const apiPath = process.env.NODE_ENV === 'production'
    ? '/api/'
    : 'http://localhost:57075/';

export const googleMapsConfig = {
    'fullscreenControl': false,
    'mapTypeControl': false,
    'streetViewControl': false,
    'zoom': 16,
    'center': {
        'lat': 3.1482766,
        'lng': 101.6941732
    }
};
